import React from "react";
import styled from "@emotion/styled";
import ChevronDownIcon from "@atlaskit/icon/glyph/chevron-down";
import FilterIcon from "@atlaskit/icon/glyph/filter";
import { COLOR_BLUE_BAYOUX } from "../../constants/styles";

import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { Grid } from "../../UI/Grid";
import { Radio } from "../../UI/Radio";
import { useNetwork } from "../../hooks/useNetwork";
import { Popover } from "../../UI/Popover";
import { ResidentStatus } from "../../constants/general";

const StyledFiltersButton = styled(Button)`
  height: 40px !important;
  padding-right: 6px !important;
  align-items: center !important;
`;

interface IProps {
  l2Information: any;
  filterState: any;
  setFilter: any;
}

export const FiltersDropdown: React.FC<IProps> = (props) => {
  const { selectedNetwork } = useNetwork();
  const [titles] = React.useState({ sex: "All", renewing: "All" });
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dropDownsInfo = [
    {
      title: titles.renewing,
      headerTitle: "Resident Status",
      key: "renewing",
      fields: [
        { name: ResidentStatus.All, id: "none" },
        { name: ResidentStatus.RenewingResident, id: "on" },
        { name: ResidentStatus.NewResident, id: "off" },
      ],
    },
    {
      title: titles.sex,
      headerTitle: props.l2Information.genderNetworkSettingsTransport.genderSelectionTitle,
      key: "sex",
      fields: props.l2Information.genderNetworkSettingsTransport.genders,
    },
  ];

  const dropDowns = dropDownsInfo
    .filter((x) => !(!selectedNetwork.apt && x.key === "renewing"))
    .filter((x) => !(!props.l2Information.smokingEnabled && x.key === "smoking"))
    .filter((x) => !(!props.l2Information.petEnabled && x.key === "pet"));

  const handleFilterChange = (key: string) => (e: any) => {
    props.setFilter((prev: any) => ({ ...prev, [key]: e.target?.name }));
  };

  return (
    <>
      <StyledFiltersButton
        appearance="primary"
        iconAfter={<ChevronDownIcon label="chevron down" />}
        iconBefore={<FilterIcon label="Filters" />}
        onClick={handleClick}
      >
        Filters
      </StyledFiltersButton>
      <Popover
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Grid container spacing={2} p={3}>
          {dropDowns.map((dropdown) => (
            <Grid item xs={12} md={6} key={dropdown.key}>
              <Grid container>
                <Grid item xs={12} mb={2}>
                  <Typography color={COLOR_BLUE_BAYOUX} variant="body2" fontWeight={600}>
                    {dropdown.headerTitle}
                  </Typography>
                </Grid>
                {dropdown.fields.map((field: any, idx: number) => (
                  <Grid item xs={12} key={`${field.id}-${idx}`}>
                    <Radio
                      name={field.name}
                      label={field.name}
                      onChange={handleFilterChange(dropdown.key)}
                      isChecked={props.filterState[dropdown.key] === field.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Popover>
    </>
  );
};
